import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DiagramSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DiagramSVG;
